/**
 * Splits an array into chunks of the given size.
 *
 * Accepts `null` or `undefined` for ergonomic use with optional values; returns `[]` in that case.
 * Uses `readonly T[]` so callers can pass mutable arrays, readonly arrays, or tuples.
 *
 * @param array the array to split (or null/undefined)
 * @param size the maximum size of each chunk; must be a positive integer
 * @returns an array of arrays, each of length up to `size`
 */
export function chunk<T>(array: readonly T[] | null | undefined, size: number): T[][] {
  if (!array) {
    return [];
  }
  const chunks: T[][] = [];
  let index = 0;

  while (index < array.length) {
    chunks.push(array.slice(index, (index += size)));
  }

  return chunks;
}
